import axios from 'apiclient';

const directusLoadContent = ({
  language, collection, pageAlias, fields,
}) => axios.post('/api/cms/content', {
  mandant: process.env.CLIENTNAME,
  language,
  collection,
  page_alias: pageAlias,
  fields,
}).then((res) => res.data);

const directusLoadList = ({
  language, collection, fields, page,
}) => axios.post('/api/cms/list', {
  mandant: process.env.CLIENTNAME,
  language,
  collection,
  fields,
  page,
}).then((res) => res.data);

export {
  directusLoadContent,
  directusLoadList,
};
